import React, { useMemo } from 'react';
import T from 'prop-types';
import { keys } from 'lodash-es';

import ChartLegend from '../../ChartLegend';
import Skeleton from '../../../../../components/Skeleton';
import { SmartChart } from '../../../../../components/Chart';
import useChartLegend from '../../../hooks/useChartLegend';
import { getChartConfig } from './config';
import {
  aiCohortsColorsMap,
  aiCohortsFillColorsMap,
  aiCohortsMap,
} from '../../../configs/constants';

const emptyObject = {};

const UsageTrendChart = ({ isPending, series = emptyObject }) => {
  const { activeItem, hoveredItem, onClick, onMouseOver, onMouseOut, classesToAdd } =
    useChartLegend();

  const cohortOrder = keys(aiCohortsMap);

  const metaSeriesData = useMemo(
    () =>
      cohortOrder.reduce(
        (acc, cohort) => ({
          ...acc,
          ...(series[cohort]
            ? {
                [cohort]: {
                  color: aiCohortsColorsMap[cohort],
                  fillColor: aiCohortsFillColorsMap[cohort],
                  name: aiCohortsMap[cohort],
                  id: cohort,
                  visible: activeItem?.id && activeItem?.id === cohort,
                  className: classesToAdd(cohort),
                },
              }
            : {}),
        }),
        {}
      ),
    [series, activeItem, hoveredItem, classesToAdd]
  );

  const chartConfig = useMemo(
    () => getChartConfig({ hoveredItem, onClick, onMouseOver, onMouseOut }),
    [hoveredItem, onClick, onMouseOver, onMouseOut]
  );

  return isPending ? (
    <Skeleton height={272} className="d-flex" />
  ) : (
    <div className="chart-container">
      <SmartChart
        chartId="app-impact-chart"
        series={series}
        metaSeriesData={metaSeriesData}
        config={chartConfig}
      />
      <ChartLegend
        series={Object.values(metaSeriesData)}
        activeItem={activeItem?.id || hoveredItem?.id}
        showTooltip
        onClick={onClick}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
      />
    </div>
  );
};

UsageTrendChart.propTypes = {
  isPending: T.bool.isRequired,
  series: T.object,
};

export default UsageTrendChart;
